<!--
 * @Author: your name
 * @Date: 2020-08-26 15:51:30
 * @LastEditTime: 2020-09-10 16:48:18
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Kares\src\components\device\TerminalLog.vue
-->
<template>
  <div class="terminal-log">
    <subfield>
      <template slot="list">
        <trees title="组织结构分组" type="GROUP" @getAssets="getAssets" :list="groupList"></trees>
      </template>
      <template slot="content">
        <enfold-cd>
          <template slot="center">
            <el-table :data="logList" style="width: 100%" v-loading="loading" height="100%">
              <el-table-column prop="device_name" :label="$t('terminal.deviceName')"></el-table-column>
              <el-table-column prop="device_sn" label="设备SN"></el-table-column>
              <el-table-column prop="group_name" label="组织结构"></el-table-column>
              <el-table-column prop="title" label="类型"></el-table-column>
              <el-table-column prop="create_time" label="操作时间" width="180"></el-table-column>
            </el-table>
          </template>
          <template slot="down">
            <pagination :current="current" :limit="limit" @currentChange="currentChange"></pagination>
          </template>
        </enfold-cd>
      </template>
    </subfield>
  </div>
</template>

<script>
import subfield from '@/components/basics/Subfield'
import EnfoldCd from '@/components/basics/EnfoldCD'
import trees from '@/components/basics/Trees'
import pagination from '@/components/basics/Pagination'
import { mPagination } from "@/components/basics/mixins";
export default {
  name: 'TerminalLog',
  mixins: [mPagination],
  data() {
    return {
      groupList: [],
      logList: [],
      loading: true,
    }
  },
  created() {
    this.$http.post("/admin/access/groupList", {}, data => {
      this.groupList = data;
    });
    this.getLogList({ limit: this.limit, page: 1, keyword: '', group_ids: this.groupIds });
  },
  methods: {
    getAssets(ids) {
      // console.log(ids);
      this.groupIds = ids.ids;
      this.getLogList({ limit: this.limit, page: 1, keyword: '', group_ids: this.groupIds });
    },
    getLogList(log) {
      this.loading = true;
      this.$http.post("/admin/device/logList", log, data => {
        this.logList = data.list ? data.list : [];
        this.current = parseInt(data.count); //获取数据的总条数
        this.logList.forEach(ele => {
          if (ele.title === '终端退出了') {
            ele.title = '退出';
          } else if (ele.title === '终端登录了') {
            ele.title = '登录';
          }
        });
        this.loading = false;
      });
    },
    currentChange(val) {
      this.getLogList({ limit: this.limit, page: val, keyword: '', group_ids: this.groupIds });
    }
  },
  components: {
    subfield,
    trees,
    pagination,
    EnfoldCd
  }
}
</script>

<style lang="scss" scoped>
.terminal-log {
  width: 100%;
  height: 100%;
  /deep/ .cell {
    font-size: 16px;
  }
  /deep/ .el-table__header-wrapper {
    .cell {
      font-size: 18px;
      color: var(--theme-color-customized-1);
    }
  }
}
</style>